import routes from './routes/support.routes';
import ModuleBase from '../../classes/ModuleBase';

export default new ModuleBase({
    name: 'Support',
    routes: routes
});